// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReportFilterDto } from './IReportFilterDto';
import {
    IReportFilterDtoFromJSON,
    IReportFilterDtoFromJSONTyped,
    IReportFilterDtoToJSON,
    IReportFilterDtoToJSONTyped,
} from './IReportFilterDto';

/**
 * 
 * @export
 * @interface IReportSchedulerUpdateDto
 */
export interface IReportSchedulerUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSchedulerUpdateDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof IReportSchedulerUpdateDto
     */
    report_type: IReportSchedulerUpdateDtoReportTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IReportSchedulerUpdateDto
     */
    report_group_type: IReportSchedulerUpdateDtoReportGroupTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IReportSchedulerUpdateDto
     */
    cron: string;
    /**
     * 
     * @type {Date}
     * @memberof IReportSchedulerUpdateDto
     */
    start_date: Date;
    /**
     * 
     * @type {Date}
     * @memberof IReportSchedulerUpdateDto
     */
    end_date: Date;
    /**
     * 
     * @type {IReportFilterDto}
     * @memberof IReportSchedulerUpdateDto
     */
    report_filter: IReportFilterDto;
}

/**
* @export
* @enum {string}
*/
export enum IReportSchedulerUpdateDtoReportTypeEnum {
    PARTICIPANT_ACCOUNT_ACTIVITY = 'PARTICIPANT_ACCOUNT_ACTIVITY',
    PAYROLL_CONTRIBUTIONS = 'PAYROLL_CONTRIBUTIONS',
    EMPLOYEE_DEMOGRAPHICS = 'EMPLOYEE_DEMOGRAPHICS',
    CLAIM_ACTIVITY = 'CLAIM_ACTIVITY',
    FORFEITURE = 'FORFEITURE',
    HEALTH_PLAN_ENROLLMENT = 'HEALTH_PLAN_ENROLLMENT',
    CARD_STATUS = 'CARD_STATUS',
    CIP_STATUS = 'CIP_STATUS',
    REPLENISHMENT_INVOICE = 'REPLENISHMENT_INVOICE',
    CONTRIBUTION_INVOICE = 'CONTRIBUTION_INVOICE',
    PREFUND_INVOICE = 'PREFUND_INVOICE',
    PLAN_OMNIBUS_BALANCE = 'PLAN_OMNIBUS_BALANCE',
    UNDELIVERABLE_ADDRESS = 'UNDELIVERABLE_ADDRESS',
    DELINQUENT_CLAIMS = 'DELINQUENT_CLAIMS'
}
/**
* @export
* @enum {string}
*/
export enum IReportSchedulerUpdateDtoReportGroupTypeEnum {
    SUMMARY = 'SUMMARY',
    BREAKDOWN = 'BREAKDOWN'
}


/**
 * Check if a given object implements the IReportSchedulerUpdateDto interface.
 */
export function instanceOfIReportSchedulerUpdateDto(value: object): value is IReportSchedulerUpdateDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('report_type' in value) || value['report_type'] === undefined) return false;
    if (!('report_group_type' in value) || value['report_group_type'] === undefined) return false;
    if (!('cron' in value) || value['cron'] === undefined) return false;
    if (!('start_date' in value) || value['start_date'] === undefined) return false;
    if (!('end_date' in value) || value['end_date'] === undefined) return false;
    if (!('report_filter' in value) || value['report_filter'] === undefined) return false;
    return true;
}

export function IReportSchedulerUpdateDtoFromJSON(json: any): IReportSchedulerUpdateDto {
    return IReportSchedulerUpdateDtoFromJSONTyped(json, false);
}

export function IReportSchedulerUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSchedulerUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'report_type': json['report_type'],
        'report_group_type': json['report_group_type'],
        'cron': json['cron'],
        'start_date': (new Date(json['start_date'])),
        'end_date': (new Date(json['end_date'])),
        'report_filter': IReportFilterDtoFromJSON(json['report_filter']),
    };
}

export function IReportSchedulerUpdateDtoToJSON(json: any): IReportSchedulerUpdateDto {
    return IReportSchedulerUpdateDtoToJSONTyped(json, false);
}

export function IReportSchedulerUpdateDtoToJSONTyped(value?: IReportSchedulerUpdateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'report_type': value['report_type'],
        'report_group_type': value['report_group_type'],
        'cron': value['cron'],
        'start_date': ((value['start_date']).toISOString().substring(0,10)),
        'end_date': ((value['end_date']).toISOString().substring(0,10)),
        'report_filter': IReportFilterDtoToJSON(value['report_filter']),
    };
}

